import { useId } from "react";

export default function LogoMark({ size = 32, className = "", glitch = false }) {
    const id = useId().replace(/:/g, "");
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 64 64"
            fill="none"
            className={`${glitch ? "glitch-mark" : ""} ${className}`.trim()}
            data-testid="logo-mark"
            aria-label="Logo Refundaja"
        >
            <defs>
                <linearGradient id={`g-${id}`} x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#FF6A5A" />
                    <stop offset="50%" stopColor="#B84BF0" />
                    <stop offset="100%" stopColor="#4E7CFF" />
                </linearGradient>
            </defs>
            <path
                d="M46.1 46.1 A20 20 0 1 1 37.2 12.68"
                stroke={`url(#g-${id})`}
                strokeWidth="9"
                strokeLinecap="round"
            />
            <polygon points="50.7,16.3 40.1,21.2 36,5.7" fill={`url(#g-${id})`} />
        </svg>
    );
}

export function Wordmark({ className = "" }) {
    return (
        <span className={`font-logo font-extrabold tracking-tight ${className}`} data-testid="wordmark">
            <span className="text-gradient glitch-text" data-text="refundaja">
                refundaja
            </span>
        </span>
    );
}
